import React from 'react';

import { renderChange, renderIdType, renderRosterNote } from '~weekly-planner/lib/common';

import { buildColumn, EditableColumnConfig } from '~components/table-view';

const createChangeColumn = (id: string, header: string) => ({
  id,
  header,
  type: 'custom' as const,
  props: {
    meta: {
      renderCustom: (_isEditing = false, row: any): React.ReactElement | null => {
        return React.createElement(renderChange, row?.[id]);
      },
    },
  },
});

const changesList: EditableColumnConfig[] = [
  {
    id: 'id',
    header: 'Id',
    type: 'custom',
    props: {
      meta: {
        renderCustom: (_isEditing = false, row: any): React.ReactElement | null => {
          return React.createElement(renderIdType, { id: row?.id, isNew: row?.isNew });
        },
      },
    },
  },
  createChangeColumn('client', 'Client'),
  createChangeColumn('service', 'Service'),
  createChangeColumn('date', 'Date'),
  createChangeColumn('time', 'Time'),
  createChangeColumn('worker', 'Worker'),
  {
    id: 'notes_admin',
    header: 'Rostering Notes',
    type: 'custom',
    props: {
      meta: {
        renderCustom: (_isEditing = false, row: any): React.ReactElement | null => {
          if (!row?.id) return null;
          return React.createElement(renderRosterNote, { id: row.id, notes_admin: row?.notes_admin });
        },
      },
    },
  },
];

export default changesList.map(buildColumn);
